import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBackgroundImageSize } from "../../../../../redux/slices/qrSettings";
import RangeInput from "../../../../../components/input/rangeInput";
import { useDebounce } from "use-debounce";

function LogoSize() {
  const lang = useSelector((state) => state.changeLang.language.stepThree.logo);
  const backgroundImageSize = useSelector(
    (state) => state.qrSettings.backgroundImageSize
  );

  const dispatch = useDispatch();
  const [logoSize, setLogoSize] = useState(backgroundImageSize);
  const [value] = useDebounce(logoSize, 300);
  useEffect(() => {
    setLogoSize(backgroundImageSize);
  }, [backgroundImageSize]);
  useEffect(() => {
    dispatch(setBackgroundImageSize(value));
  }, [value]);

  return (
    <div className="d-flex">
      <div className="me-3 text-nowrap text-capitalize">{lang[0]}</div>
      <RangeInput
        id={"logoSizeInput"}
        onChange={setLogoSize}
        defaultValue={logoSize}
        min={0.1}
        max={1}
        step={0.1}
      />
    </div>
  );
}

export default LogoSize;
